<template>
  <el-dialog :visible.sync="visible" :title="!dataForm.id ? $t('add') : $t('update')" :close-on-click-modal="false"
             :close-on-press-escape="false">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" label-width="120px">
      <el-form-item label="所属分组" prop="groupId">
        <el-select v-model="dataForm.groupId">
          <el-option v-for="item in groupList" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="列表名称：" prop="name">
        <el-input v-model="dataForm.name" placeholder=""></el-input>
      </el-form-item>
      <el-form-item label="引用键值：" prop="useKey">
        <el-input v-model="dataForm.useKey" placeholder="引用键值"></el-input>
      </el-form-item>
      <el-form-item label="接口地址：" prop="url">
        <el-input v-model="dataForm.url" placeholder="接口地址"></el-input>
      </el-form-item>
    </el-form>
    <template slot="footer">
      <el-button @click="cancel">{{ $t('cancel') }}</el-button>
      <el-button type="primary" @click="dataFormSubmitHandle()">{{ $t('confirm') }}</el-button>
    </template>
  </el-dialog>
</template>

<script>
import debounce from 'lodash/debounce'

export default {
  data () {
    return {
      id: '',
      visible: false,
      groupList: [],
      dataForm: {
        id: '',
        groupId: '',
        name: '',
        pager: '',
        rowNo: '',
        selection: '',
        useKey: '',
        url: ''
      }
    }
  },
  computed: {
    dataRule () {
      return {
        groupId: [
          { required: true, message: this.$t('validate.required'), trigger: 'change' }
        ], name: [
          { required: true, message: this.$t('validate.required'), trigger: 'change' }
        ], pager: [
          { required: true, message: this.$t('validate.required'), trigger: 'change' }
        ], rowNo: [
          { required: true, message: this.$t('validate.required'), trigger: 'change' }
        ], selection: [
          { required: true, message: this.$t('validate.required'), trigger: 'change' }
        ], useKey: [
          { required: true, message: this.$t('validate.required'), trigger: 'change' }
        ], url: [
          { required: true, message: this.$t('validate.required'), trigger: 'change' }
        ]
      }
    }
  },
  methods: {
    async queryGroupList () {
      let res =await this.$api.get(`/sys/table/group/page`, { params: { page: 1, limit: 10000 } })
      this.groupList = res.list
    },
    reset () {
      this.dataForm = {
        groupId: '', name: '', pager: '', rowNo: '', selection: '', useKey: '', url: ''
      }
      if (this.$refs['dataForm']) {
        this.$refs['dataForm'].resetFields()
      }
    },
    init () {
      this.queryGroupList()
      this.visible = true
      this.$nextTick(() => {
        this.reset()
        if (this.id) {
          this.getInfo()
        }
      })
    },
    // 获取信息
    getInfo () {
      this.$http.get(`/sys/table/${this.id}`).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.dataForm = {
          ...this.dataForm,
          ...res.data
        }
      }).catch(() => {
      })
    },

    // 表单提交
    dataFormSubmitHandle: debounce(function () {
      this.$refs['dataForm'].validate((valid) => {
        if (!valid) {
          return false
        }
        let postForm = {
          ...this.dataForm
        }
        this.$http[!postForm.id ? 'post' : 'put']('/sys/table', postForm).then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          this.$message({
            message: this.$t('prompt.success'),
            type: 'success',
            duration: 500,
            onClose: () => {
              this.cancel()
              this.$emit('refreshDataList')
            }
          })
        }).catch(() => {
        })
      })
    }, 1000, { 'leading': true, 'trailing': false }),
    cancel () {
      this.visible = false
    }
  }
}
</script>
